// Google "G" logo — official 4-color mark. Inlined as SVG so the auth
// pages don't pull a brand-icons npm package. Sized to match the
// lucide Apple icon used on the paired Apple Sign In button.

interface Props {
  size?: number;
}

export function GoogleIcon({ size = 18 }: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path fill="#4285F4" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.6-6 8-11.3 8a12 12 0 1 1 0-24c3.1 0 5.9 1.2 8 3.1l5.7-5.7A20 20 0 1 0 24 44c11 0 20-9 20-20 0-1.2-.1-2.4-.4-3.5z" />
      <path fill="#34A853" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2A12 12 0 0 1 12.7 28l-6.6 5.1A20 20 0 0 0 24 44z" />
      <path fill="#FBBC05" d="M12.7 28A12 12 0 0 1 12 24c0-1.4.3-2.8.7-4l-6.6-5.1A20 20 0 0 0 4 24c0 3.3.8 6.4 2.1 9.1l6.6-5.1z" />
      <path fill="#EA4335" d="M24 12c3.1 0 5.9 1.1 8.1 3l6-6A20 20 0 0 0 6.1 14.9l6.6 5.1A12 12 0 0 1 24 12z" />
    </svg>
  );
}
